import { render, staticRenderFns } from "./SendDigitalGift.vue?vue&type=template&id=dc4b8b62&scoped=true&"
import script from "./SendDigitalGift.vue?vue&type=script&lang=js&"
export * from "./SendDigitalGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4b8b62",
  null
  
)

export default component.exports